export default {
    elements_selector: '.lazy',
    unobserve_entered: true,
}
